export interface QuestionPackIncludes {
  css: string[];
  js: string[];
}

export function joinPaths(base: string, path: string): string {
  const baseLength = base.length;
  const pathLength = path.length;

  if (pathLength === 0 || baseLength === 0) throw new Error("Both base and path must be non-empty strings.");

  const baseEndsWithSlash = base[baseLength - 1] === "/";
  const pathStartsWithSlash = path[0] === "/";

  if (baseEndsWithSlash && pathStartsWithSlash) return base + path.slice(1);
  if (baseEndsWithSlash || pathStartsWithSlash) return base + path;
  return `${base}/${path}`;
}

export async function loadVendorFiles(
  document: Document,
  basePath: string,
  includes: QuestionPackIncludes,
  onProgress: (idx: number) => void,
): Promise<void> {
  for (const href of includes.css) {
    const normalizedHref = joinPaths(basePath, href);

    if (document.querySelector(`link[href="${normalizedHref}"]`) == null) {
      const link = Object.assign(document.createElement("link"), {
        href: normalizedHref,
        rel: "stylesheet",
        type: "text/css",
      });
      document.head.appendChild(link);
    }
  }

  for (let i = 0; i < includes.js.length; i++) {
    const rawSrc = includes.js[i];
    const src = joinPaths(basePath, rawSrc);

    if (document.querySelector(`script[src="${src}"]`) == null) {
      await new Promise<void>((resolve, reject) => {
        const script = Object.assign(document.createElement("script"), { src, type: "text/javascript" });
        script.addEventListener("load", () => resolve());
        script.addEventListener("error", (e) => reject(e));
        document.body.appendChild(script);
      });
    }

    onProgress(i + 1);
  }
}
